export default "__VITE_ASSET__9201daa6__"